/**
 * Email configuration for Clínica Dr. Guilherme Galvão.
 * Cloud Function URL is built from Firebase project ID.
 * Resend API key and reCAPTCHA secret are stored in Firebase secrets.
 */

const firebaseProjectId =
  process.env.REACT_APP_FIREBASE_PROJECT_ID || 'clinica-osteopatia';

const CLOUD_FUNCTION_URL = firebaseProjectId
  ? `https://europe-west1-${firebaseProjectId}.cloudfunctions.net/sendEmail`
  : '';

export const emailConfig = {
  CLOUD_FUNCTION_URL,

  FROM_EMAIL: process.env.REACT_APP_RESEND_FROM_EMAIL || 'noreply@clinicaosteopatia.pt',
  FROM_NAME: process.env.REACT_APP_RESEND_FROM_NAME || 'Clínica Dr. Guilherme Galvão',

  /** Admin inbox for appointment requests */
  TO_EMAIL: process.env.REACT_APP_RESEND_TO_EMAIL || 'info@clinicaosteopatia.pt',

  /** Logo URL for email templates */
  LOGO_URL: process.env.REACT_APP_EMAIL_LOGO_URL || '',
};
